import app from 'src/AspediaVueJSDrupalWebsite'
import routes from './routes.json'
import homepage from './components/homepage'
import fetch from 'cross-fetch'
import applogger from '@applogger'

if (process.env.SERVER_BUILD !== 'ssr') {
  window.applogger = applogger
  if (!window.fetch) window.fetch = fetch
}
else {
  global.applogger = applogger
  global.fetch = fetch
}

// Add our custom site home page.
app.addStartup('homepage', homepage)

// Add routes data.
app.addRoutes(routes)

export {
  app
}
